export { default } from './BorrowingList';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingList/index.js